import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, AppNotification } from '../../services/notification.service';

@Component({
  selector: 'app-global-notification-stack',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-notification-stack.html',
  styleUrl: './global-notification-stack.css'
})
export class GlobalNotificationStackComponent {
  constructor(public notifications: NotificationService) {}

  trackById(_index: number, item: AppNotification): string {
    return item.id;
  }

  levelAriaLive(level: AppNotification['level']): 'polite' | 'assertive' {
    return level === 'error' ? 'assertive' : 'polite';
  }
}
